// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AYhA","field":"styles_field__1hrli","fieldCol":"styles_fieldCol__3_bHb","diffCol":"styles_diffCol__3bY4X","diff":"styles_diff__Yj7aA"};